// extracted by mini-css-extract-plugin
module.exports = {"FourOhFour":"FourOhFour_FourOhFour__KMLvF","inner":"FourOhFour_inner__UUXq5","title":"FourOhFour_title___XDlc","link":"FourOhFour_link__kPhW7"};